import { render } from "./heading-with-filter.vue?vue&type=template&id=7ff7b41a&scoped=true&ts=true"
import script from "./heading-with-filter.vue?vue&type=script&lang=ts"
export * from "./heading-with-filter.vue?vue&type=script&lang=ts"

import "./styles/heading-with-filter.scss?vue&type=style&index=0&id=7ff7b41a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff7b41a"]])

export default __exports__